const env = process.env.REACT_APP_ENV_TYPE;

let projectSetting = {};
if (env === "dev3") {
  projectSetting = {
    baseURL: "https://dev3.procareportal.com/",
    backend: "backend/",
    version: "v1",
    valid_otp_time: "05:00",
    encrypt_api_param: true,
    socket_url: "wss://dev3.procareportal.com",
  };
} else if (env === "dev2") {
  projectSetting = {
    baseURL: "https://dev2.procareportal.com/",
    backend: "backend/",
    version: "v1",
    valid_otp_time: "05:00",
    encrypt_api_param: false,
    socket_url: "wss://dev2.procareportal.com",
  };
} else if (env === "localhost") {
  projectSetting = {
    baseURL: "http://qa.procareportal.local/",
    backend: "backend/",
    version: "v1",
    valid_otp_time: "05:00",
    encrypt_api_param: false,
    socket_url: "ws://qa.procareportal.local",
  };
} else if (env === "qa") {
  projectSetting = {
    baseURL: "https://sandbox.procareportal.com/",
    backend: "backend/",
    version: "v1",
    valid_otp_time: "05:00",
    encrypt_api_param: false,
    socket_url: "wss://sandbox.procareportal.com",
  };
} else if (env === "demo") {
  projectSetting = {
    baseURL: "https://sandbox.procareportal.com/",
    backend: "backend/",
    version: "v1",
    valid_otp_time: "05:00",
    encrypt_api_param: true,
    socket_url: "wss://sandbox.procareportal.com",
  };
} else {
  projectSetting = {
    baseURL: "https://client.procareportal.com/",
    backend: "backend/",
    version: "v1",
    valid_otp_time: "05:00",
    encrypt_api_param: true,
    socket_url: "wss://client.procareportal.com",
  };
}

export default projectSetting;
